import { toast } from 'sonner';
import type { UpdateHubspotTicketStatusResponse } from '../types';

export function showTicketStatusUpdateToast({
  baseMessage,
  approvalEmail,
  rejectionEmail,
}: {
  baseMessage: string;
  approvalEmail: UpdateHubspotTicketStatusResponse['approvalEmail'];
  rejectionEmail: UpdateHubspotTicketStatusResponse['rejectionEmail'];
}) {
  if (rejectionEmail) {
    const recipientSuffix = rejectionEmail.recipientEmail
      ? ` to ${rejectionEmail.recipientEmail}`
      : '';

    if (rejectionEmail.error) {
      toast.error(
        `${baseMessage}, but the publisher email could not be sent: ${rejectionEmail.error}`,
      );
      return;
    }

    if (rejectionEmail.alreadySent) {
      toast.success(
        `${baseMessage}. Publisher email was already sent${recipientSuffix}`,
      );
      return;
    }

    if (rejectionEmail.sent) {
      toast.success(`${baseMessage}. Publisher email sent${recipientSuffix}`);
      return;
    }

    toast.success(baseMessage);
    return;
  }

  if (!approvalEmail) {
    toast.success(baseMessage);
    return;
  }

  const recipientSuffix = approvalEmail.recipientEmail
    ? ` to ${approvalEmail.recipientEmail}`
    : '';

  if (approvalEmail.error) {
    toast.error(
      `${baseMessage}, but the publisher email could not be sent: ${approvalEmail.error}`,
    );
    return;
  }

  if (approvalEmail.alreadySent) {
    toast.success(
      `${baseMessage}. Publisher email was already sent${recipientSuffix}`,
    );
    return;
  }

  if (approvalEmail.deferred) {
    toast.success(
      `${baseMessage}. Publisher email will send once this version is live${recipientSuffix}`,
    );
    return;
  }

  if (approvalEmail.sent) {
    toast.success(`${baseMessage}. Publisher email sent${recipientSuffix}`);
    return;
  }

  toast.success(baseMessage);
}
